import { render, staticRenderFns } from "./fccSelecaoDeFaseEGrupo.vue?vue&type=template&id=0aeb61cc"
import script from "./fccSelecaoDeFaseEGrupo.vue?vue&type=script&lang=js"
export * from "./fccSelecaoDeFaseEGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports